import { getRequest } from 'config/Axios/baseConfig';
import {
  ApiResponse,
  ProductCalculationsResponse,
} from 'Interfaces/CalculationInterfaces/MainCalculationInterfaces';

export const productCalculationServices = {
  getProductCalculations: (
    date?: string,
    includeCompleted: boolean = false
  ): Promise<ProductCalculationsResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        // Use today's date if no date is provided
        const targetDate = date || new Date().toISOString().split('T')[0];

        const { data } = await getRequest<ApiResponse<ProductCalculationsResponse>>(
          `pps/calculations/get-product-calculations/?date=${targetDate}&include_completed=${includeCompleted}`
        );

        resolve(data.data || []);
      } catch (error: any) {
        reject(error);
      }
    });
  }
};
